// extracted by mini-css-extract-plugin
module.exports = {"profile":"profile_profile__2UfhZ","entries":"profile_entries__2E_mG","loader":"profile_loader__3nygf"};